import styled from 'styled-components'

const Container = styled.section`
  position: relative;
  min-height: 280px;
  padding-bottom: 20px;
  clear: left;
`

const Headline = styled.h2`
  margin-bottom: 20px;
`

export { Container, Headline }
